import { render, staticRenderFns } from "./ProjetEtapes.vue?vue&type=template&id=449fbd1f&scoped=true&lang=true&"
import script from "./ProjetEtapes.vue?vue&type=script&lang=js&"
export * from "./ProjetEtapes.vue?vue&type=script&lang=js&"
import style0 from "./ProjetEtapes.vue?vue&type=style&index=0&id=449fbd1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449fbd1f",
  null
  
)

export default component.exports